import cx from 'classnames'
import Styles from './WorkflowReassignmentsModal.module.scss'
import { State } from 'stores/Workflows/State'
import { PropertyValuePill } from 'components/PropertyValuePill/PropertyValuePill'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { Key } from 'react'
import { ReactComponent as ChevronRight } from 'assets/icons/chevronRight16.svg'
import { Tooltip } from 'components/Tooltip/Tooltip'

interface Props {
  fromState: State
  toState: State
  newStates: State[]
  onChange: (fromState: State, toState: State) => void
}

const canBeAssigned = (state: State) => state.isPersisted && !state.entryAction

export const Row = ({ fromState, toState, newStates, onChange }: Props) => {
  const handleSelectionChange = (key: Key) => {
    const newToState = newStates.find((state) => state.key === key)
    if (!newToState) {
      return
    }
    onChange(fromState, newToState)
  }

  const disabledKeys = newStates.filter((state) => !canBeAssigned(state)).map((state) => state.key)

  return (
    <>
      <div className={Styles.cell}>
        <PropertyValuePill propertyValue={{ value: fromState.value, meta: fromState.propertyValue.meta }} />
      </div>
      <div className={cx(Styles.cell, Styles.separator)}>
        <ChevronRight />
      </div>
      <div className={Styles.cell}>
        <Select
          aria-label={`Reassignment for ${fromState.value}`}
          selectedKey={toState.key}
          onSelectionChange={handleSelectionChange}
          disabledKeys={disabledKeys}
        >
          {newStates.map((newState) => (
            <Item key={newState.key} textValue={newState.value}>
              <Tooltip
                label="Files cannot be assigned to a new or automated status."
                hide={canBeAssigned(newState)}
                placement="right"
              >
                <div style={{ width: '100%' }}>
                  <PropertyValuePill propertyValue={{ value: newState.value, meta: newState.propertyValue.meta }} />
                </div>
              </Tooltip>
            </Item>
          ))}
        </Select>
      </div>
    </>
  )
}
